<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'despatch-order-list'"
    :gcPopupConfig="gcPopupConfig"
    :gcSOPayNowPopupConfig="gcSOPayNowPopupConfig"
    :gcSOPartPickPopupConfig="gcSOPartPickPopupConfig"
    ref="despatch-order-list"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { DespatchOrderListService } from "../../_services/api/sales/despatch-order-list.service";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { FeatureStorage } from "../../_services/storage";
import { SalesOrderService } from "../../_services/api/sales/sales-order.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      despatchSalesOrderScreenVersion: "V1",
      gcPopupVisible: false,
      adjustShipDateDataModel: {
        SalesOrder: undefined,
        Customer: undefined,
        ShipDate: undefined,
        RequiredByDate: undefined,
        NewShipDate: undefined,
      },
      NewShipDate: {
        Min: undefined,
        Value: undefined,
      },
      payNowPopupProps: {
        visible: false,
        salesOrderCode: undefined,
        customerCode: undefined,
        customerName: undefined,
        orderAmount: undefined,
        callback: () => {},
      },
      partPickPopupProps: {
        visible: false,
        salesOrderCode: undefined,
        customerName: undefined,
        customerCode: undefined,
        shipDate: undefined,
        requiredByDate: undefined,
        callback: () => {},
      },
    };
  },
  computed: {
    gcSOPartPickPopupConfig() {
      return this.partPickPopupProps;
    },
    gcSOPayNowPopupConfig() {
      return this.payNowPopupProps;
    },
    allowPopupUpdate() {
      if (
        this.NewShipDate.Value != undefined &&
        this.adjustShipDateDataModel.ShipDate != undefined
      ) {
        let time1 = this.NewShipDate.Value.getTime();
        let time2 = this.adjustShipDateDataModel.ShipDate.getTime();
        return time1 == time2;
      } else {
        return true;
      }
    },
    gcPopupConfig() {
      return {
        title: `Adjust SO Dates for SO #${this.adjustShipDateDataModel.SalesOrder}`,
        dataModel: this.adjustShipDateDataModel,
        callback: this.adjustShipDateCallback,
        callBack: this.adjustShipDateCallback,
        gcPopupVisible: this.gcPopupVisible,
        height: 275,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            dataField: "SalesOrder",
            label: {
              text: "Sales Order #",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            dataField: "Customer",
            label: {
              text: "Customer",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            screenField: "ShipDate",
            dataField: "RequiredByDate",

            label: {
              text: "Required By Date",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            screenField: "ShipDate",
            dataField: "ShipDate",
            label: {
              text: "Current Ship Date",
            },
            editorOptions: {
              readOnly: true,
            },
          },
          {
            screenField: "ShipDate",
            dataField: "NewShipDate",
            label: {
              text: "New Ship Date",
            },
            editorOptions: {
              min: this.NewShipDate.Min,
              allowUpdate: true,
              onValueChanged: (e) => {
                if (e.event) this.onChangeNewShipDate(e);
              },
            },
          },
        ],
        save: {
          text: "Update",
          clickCallback: (e) => {
            this.onGcPopUpUpdate(e);
          },
          disabled: this.allowPopupUpdate,
        },
        back: {
          text: "Cancel",
          clickCallback: () => {
            this.adjustShipDateCallback();
          },
        },
      };
    },
    despatchSalesOrderRouteForRowClick() {
      if (this.despatchSalesOrderScreenVersion == "V2") {
        return "despatch-order-v2";
      } else {
        return "despatch-order";
      }
    },
    setScreenConfig() {
      var config = {
        title: "Sales Orders",
        ScreenName: "Sales Orders - To Despatch",
        selectedIndex: GetIndexByTabName("To Despatch"),
        tabs: SalesOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesOrderList",
              filter: [
                [["Status", "=", "A"], "or", ["Status", "=", "L"]],
                "and",
                ["StopCredit", "=", "N"],
              ],
              serverPaging: true,
              allowGrouping: false,
              key: "Code",
              select: [
                "Status",
                "StopCredit",
                "CodeComputedString",
                "Code",
                "CustomerCode",
                "CustomerName",
                "BranchCode",
                "BranchDescription",
                "OrderNo",
                "MarketCode",
                "ShipDate",
                "SalesRepresentativeFullName",
                "SalesRepresentativeCode",
                "DateIn",
                "RequiredByDate",
                "CustomerSalesRepresentativeCode",
                "CustomerSalesRepresentativeFullName",
                "DeliveryAddressCompanyName",
                "FriendlyStatus",
                "InvoiceFriendlyStatus",
                "FxTotal",
                "CustomerSalesContractName",
                "CustomerSalesContractCode",
                "SalesOrderTypeCode",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "hooray",
                title: "No Orders",
                message:
                  "Your work is complete, all orders have been despatched.",
              },
            },
            options: {
              selectionMode: "multiple",
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            multiplePdf: true,
            export: false,
            openFilter: true,
            expand: false,
            screenName: "Sales Orders - To Despatch",
          },
          columns: [
            {
              screenField: "SalesOrder",
              gridDataField: "CodeComputedString",
              dataField: "CodeComputedString",
              calculateSortValue: "Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              maxWidth: ColumnWidth.SalesOrderNumber.width,
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 0,
            },
            {
              screenField: "Customer",
              filterIndex: 4,
            },
            {
              screenField: "Branch",
              filterIndex: 5,
              visible: false,
            },
            {
              screenField: "CustPO",
              gridDataField: "OrderNo",
              filterDataField: "OrderNo",
              dataType: "string",
              type: "Text",
              filterIndex: 1,
              maxWidth: ColumnWidth.CustPO.width,
            },
            {
              screenField: "Market",
              dataField: "MarketCode",
              filterDataField: "MarketCode",
              filterIndex: 10,
              maxWidth: ColumnWidth.Market.width,
            },
            {
              screenField: "ShipDate",
              gridLabel: "Ship Date",
              filterIndex: 7,
            },
            {
              screenField: "OrderRep",
              visible: false,
              gridDataField: "SalesRepresentativeFullName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SalesRepresentativeFullName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SalesRepresentativeCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SalesRepresentativeCode",
                  label: "Order Rep Code",
                },
                {
                  dataField: "SalesRepresentativeFullName",
                  label: "Order Rep Full Name",
                  allowSearch: false,
                },
              ],
              filterDataField: "SalesRepresentativeCode",
              filterIndex: 12,
            },
            {
              screenField: "DateIn",
              gridLabel: "Date In",
              filterLabel: "Date In",
              visible: false,
              filterIndex: 6,
            },
            {
              screenField: "RequiredByDate",
              gridLabel: "Reqd Date",
              filterLabel: "Reqd Date",
              filterDataField: "RequiredByDate",
              filterIndex: 8,
            },
            {
              screenField: "ProductAcct",
              visible: false,
              filterIndex: 9,
              filterOperator: "contains",
              gridDataField: "NotDespatchedItemCodeList",
              filterDataField: "NotDespatchedItemCodeList",
              showInColumnChooser: false,
            },
            {
              screenField: "CustomerRep",
              visible: false,
              filterIndex: 11,
            },
            {
              screenField: "DeliveryCompany",
              visible: false,
              gridLabel: "Delivery Company",
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 2,
              dataSourceConfig: {
                data: ["Active", "Locked"],
              },
            },
            {
              screenField: "OrderStatus",
              gridDataField: "InvoiceFriendlyStatus",
              filterDataField: "InvoiceFriendlyStatus",
              filterIndex: 3,
              filterLabel: "Invoice Status",
              dataSourceConfig: {
                data: ["Invoiced", "Pending Invoice"],
              },
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Lock Order",
                      data: data,
                      clickAction: this.lockOrder,
                      visible:
                        data.data.FriendlyStatus != "Locked" ? true : false,
                    },
                    {
                      menuText: "Unlock Order",
                      data: data,
                      clickAction: this.unLockOrder,
                      visible:
                        data.data.FriendlyStatus == "Locked" ? true : false,
                    },
                    {
                      menuText: `Complete Order`,
                      data: data,
                      clickAction: this.completeSalesOrder,
                      visible:
                        FeatureStorage.checkPermission(
                          "SalesOrder",
                          "create"
                        ) &&
                        data.data.Status == "A" &&
                        data.data.Invoice != 0,
                    },
                    {
                      menuText: `Adjust SO Dates`,
                      data: data,
                      clickAction: this.showAdjustShipDatePopup,
                      visible:
                        FeatureStorage.checkPermission(
                          "SalesOrder",
                          "create"
                        ) &&
                        data.data.Status != "X" &&
                        data.data.Status != "C",
                    },
                    {
                      menuText: `Pay Now`,
                      data: data,
                      clickAction: this.showPayNowSalesOrder,
                      visible:
                        (FeatureStorage.checkPermission(
                          "CashReceipt",
                          "CashReceipt",
                          "read"
                        ) ||
                          FeatureStorage.checkPermission(
                            "CashReceipt",
                            "create"
                          )) &&
                        (data.data.Status == "A" || data.data.Status == "H"),
                      disabled: !FeatureStorage.checkPermission(
                        "CashReceipt",
                        "create"
                      ),
                    },
                    {
                      menuText: `Part Pick`,
                      data: data,
                      clickAction: this.showPartPickSalesOrder,
                      visible:
                        (FeatureStorage.checkPermission("SalesOrder", "read") ||
                          FeatureStorage.checkPermission(
                            "SalesOrder",
                            "create"
                          )) &&
                        (data.data.Status == "A" || data.data.Status == "P"),
                      disabled: !FeatureStorage.checkPermission(
                        "SalesOrder",
                        "create"
                      ),
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
            {
              screenField: "Contract",
              label: {
                text: "Contract",
              },
              gridDataField: "CustomerSalesContractName",
              visible: false,
              showInColumnChooser: false,
              filterDataField: "CustomerSalesContractCode",
              filterIndex: 13,
              cellTemplate: "",
              cellTemplateRecord: "",
            },
            {
              screenField: "OrderType",
              filterIndex: 14,
              filterDataField: "SalesOrderTypeCode",
              filterLabel: "SO Type",
              cellTemplate: "",
              cellTemplateRecord: "",
              visible: false,
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    showPartPickSalesOrder(data) {
      this.partPickPopupProps.visible = true;
      this.partPickPopupProps.salesOrderCode = data.Code;
      this.partPickPopupProps.customerCode = data.CustomerCode;
      this.partPickPopupProps.customerName = data.CustomerName;
      this.partPickPopupProps.shipDate = data.ShipDate;
      this.partPickPopupProps.requiredByDate = data.RequiredByDate;
      this.partPickPopupProps.callback = this.partPickCallback;
    },
    partPickCallback() {
      this.partPickPopupProps.visible = false;
    },
    payNowCallback(paymentCreated, salesOrderCode) {
      this.payNowPopupProps.visible = false;
      if (paymentCreated) {
        this.$notify(
          `Successfully created payment for SO ${salesOrderCode}`,
          "success"
        );

        this.$refs["despatch-order-list"].$refs[
          "transactionListGrid"
        ].gridRepaint();
      }
    },
    showPayNowSalesOrder(data) {
      this.payNowPopupProps.visible = true;
      this.payNowPopupProps.salesOrderCode = data.Code;
      this.payNowPopupProps.customerCode = data.CustomerCode;
      this.payNowPopupProps.customerName = data.CustomerName;
      this.payNowPopupProps.orderAmount = data.FxTotal;
      this.payNowPopupProps.callback = this.payNowCallback;
    },
    async completeSalesOrder(data) {
      let payload = {
        SalesOrderCode: data.Code,
      };
      await SalesOrderService.completeSalesOrder(payload)
        .then(() => {
          this.$notify(`SO #${data.Code} has been completed.`, "success");

          this.$refs["despatch-order-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify(`SO #${data.Code} could not be completed.`, "error");
        });
    },
    onChangeNewShipDate(e) {
      this.NewShipDate.Value = e.value;
    },
    async showAdjustShipDatePopup(data) {
      this.setLoading = true;

      this.adjustShipDateDataModel = {
        SalesOrder: `${data.Code}`,
        Customer: data.CustomerName,
        RequiredByDate: data.RequiredByDate,
        ShipDate: data.ShipDate,
        NewShipDate: data.ShipDate,
      };

      this.NewShipDate.Min = new Date();
      this.NewShipDate.Value = data.ShipDate;

      this.setLoading = false;
      this.gcPopupVisible = true;
    },
    async onGcPopUpUpdate(e) {
      this.adjustShipDateCallback();
      let payLoad = {
        SalesOrderCode: e.SalesOrder,
        ShipDate: e.NewShipDate,
        RequiredByDate: e.RequiredByDate,
      };
      await SalesOrderService.adjustShipDate(payLoad)
        .then((res) => {
          this.$notify(
            `SO #${res.data.SalesOrderCode} ship date has been updated.`,
            "success"
          );

          this.$refs["despatch-order-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify(
            `SO #${this.adjustShipDateDataModel.SalesOrder} failed to update`,
            "error"
          );
        });
    },
    adjustShipDateCallback() {
      this.gcPopupVisible = false;
    },
    async setDespatchOrderScreenNavigation() {
      await SettingsService.getBySettingName("DespatchSalesOrderVersionInUse")
        .then((res) => {
          if (res.data.value.length > 0) {
            this.despatchSalesOrderScreenVersion =
              res.data.value[0].SettingValue;
          }
        })
        .catch((err) => {
          this.$logger.debug(err);
        });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "OrderStatus" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.screenField != "GridRecordEllipsisMenu" &&
        e.column.type != "selection"
      ) {
        if (this.formsConfig.editableOption) {
          this.onRowClicked(e, {
            view: this,
            page: this.despatchSalesOrderRouteForRowClick,
            mode: "edit",
            idProperty: "Code",
          });
        } else if (this.formsConfig.reviewOption) {
          this.onRowClicked(e, {
            view: this,
            page: "despatch-order",
            mode: "review",
            idProperty: "Code",
          });
        }
      }
    },
    lockOrder(e, grid) {
      this.setLoading = true;
      DespatchOrderListService.lockOrder({
        Code: e.Code,
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.setLoading = false;
          // this.$logger.debug("result ", result);
          grid.refresh(true);
        })
        .catch((error) => {
          this.setLoading = false;
          this.displayServerError(error, "Order lock Failed");
          this.$store.dispatch("ui/setServerError", {
            error: error,
            title: "Order lock Failed",
          });
        });
    },
    unLockOrder(e, grid) {
      this.setLoading = true;
      DespatchOrderListService.unlockOrder({
        Code: e.Code,
      })
        // eslint-disable-next-line no-unused-vars
        .then((result) => {
          this.setLoading = false;
          // this.$logger.debug("result ", result);
          grid.refresh(true);
        })
        .catch((error) => {
          this.setLoading = false;
          this.displayServerError(error, "Order unlock Failed");
          this.$store.dispatch("ui/setServerError", {
            error: error,
            title: "Order unlock Failed",
          });
        });
    },
  },
  async created() {
    this.setLoading = true;
    await this.setDespatchOrderScreenNavigation();
  },
};
</script>

<style lang="scss"></style>
